import React from 'react';
import PropTypes from 'prop-types';
import PhoneNumbersSelector from './types/PhoneNumbersSelector';
import Chat from './types/Chat';
import Email from './types/Email';
import Telephone from './types/Telephone';
import Url from './types/Url';

const ContactSelector = ({
    cms,
    storeOpened,
    activateAnalytics,
    PHRASE_TRANSLATIONS,
    index,
    phoneNumbers,
}) => {
    const { contactType } = cms;
    const colorButton = index <= 0 ? 'primary' : 'secondary';
    const buttonStyles = 'card__button';
    const ariaLabel = storeOpened ? PHRASE_TRANSLATIONS.isOpen : PHRASE_TRANSLATIONS.isClosed;
    const ariaLabelForTelephone = storeOpened
        ? `${PHRASE_TRANSLATIONS.isOpen}. ${PHRASE_TRANSLATIONS.noCharge}`
        : `${PHRASE_TRANSLATIONS.isClosed}. ${PHRASE_TRANSLATIONS.noCharge}`;

    switch (contactType) {
        case 'telephone':
        case 'telephone-business':
        case 'telephone-kitchen':
            if (!cms.phoneNumber && phoneNumbers && phoneNumbers?.length === 0) return null;
            if (phoneNumbers && phoneNumbers?.length > 1)
                return (
                    <PhoneNumbersSelector
                        phoneNumbers={phoneNumbers}
                        storeOpened={storeOpened}
                        colorButton={colorButton}
                        buttonStyles={buttonStyles}
                        activateAnalytics={() => activateAnalytics('Button')}
                        ariaLabel={ariaLabelForTelephone}
                        PHRASE_TRANSLATIONS={PHRASE_TRANSLATIONS}
                    />
                );
            return (
                <Telephone
                    phoneNumber={(phoneNumbers && phoneNumbers[0]?.phoneNumber) || cms.phoneNumber}
                    contactLabel={cms.contactLabel}
                    storeOpened={storeOpened}
                    activateAnalytics={() => activateAnalytics('Button')}
                    colorButton={colorButton}
                    buttonStyles={buttonStyles}
                    ariaLabel={ariaLabelForTelephone}
                />
            );
        case 'chat':
        case 'chatbot':
            return (
                <Chat
                    cms={cms}
                    storeOpened={storeOpened}
                    activateAnalytics={() => activateAnalytics('Button')}
                    colorButton={colorButton}
                    buttonStyles={buttonStyles}
                    ariaLabel={ariaLabel}
                />
            );
        case 'url':
            return (
                <Url
                    cms={cms}
                    storeOpened={storeOpened}
                    activateAnalytics={() => activateAnalytics('Button')}
                    colorButton={colorButton}
                    buttonStyles={buttonStyles}
                    ariaLabel={ariaLabel}
                />
            );
        case 'email':
            return (
                <Email
                    contactLabel={cms.contactLabel}
                    buttonLink={cms?.buttonLink}
                    storeOpened={storeOpened}
                    activateAnalytics={() => activateAnalytics('Button')}
                    colorButton={colorButton}
                    buttonStyles={buttonStyles}
                    ariaLabel={ariaLabel}
                />
            );
        default:
            return null;
    }
};

ContactSelector.propTypes = {
    cms: PropTypes.object,
    activateAnalytics: PropTypes.func,
    ariaLabel: PropTypes.string,
    index: PropTypes.number,
    contactType: PropTypes.string,
    contactLabel: PropTypes.string,
    colorButton: PropTypes.string,
    buttonStyles: PropTypes.string,
    storeOpened: PropTypes.bool,
    phoneNumbers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            phoneNumber: PropTypes.string,
            identifier: PropTypes.string,
            createdAt: PropTypes.string,
            entityName: PropTypes.string,
            updatedAt: PropTypes.string,
        }),
    ),
    PHRASE_TRANSLATIONS: PropTypes.object,
};
export default ContactSelector;
